module.exports = __webpack_public_path__ + "d60a1ba50679f0221cb9113972e7cef5.pdf";